export enum OrderType {
  PRE_ORDER = 'PRE_ORDER',
  READY_FOR_DELIVERY = 'READY_FOR_DELIVERY',
  BOTH = 'BOTH',
}
